import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Text Content */}
          <div className="fade-in space-y-8">
            <div className="inline-flex items-center px-4 py-2 bg-background-muted rounded-full border border-border-light">
              <Sparkles className="w-4 h-4 text-accent mr-2" />
              <span className="text-sm font-medium text-foreground-muted">Expert Precision Engineering Solutions</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-primary leading-tight">
              Engineering the Future of{' '}
              <span className="text-gradient-gold">Fabrication</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-foreground-muted leading-relaxed max-w-xl">
              WeldPoint delivers high-tolerance welding solutions for complex industrial challenges across South Africa. 
              Combining cutting-edge technology with expert knowledge, we transform engineering visions into reality.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold text-base shadow-elegant group"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Partner With Us
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold text-base"
                onClick={() => document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Our Process
              </Button>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-8 pt-4 border-t border-border-light">
              <div>
                <p className="text-3xl font-serif font-bold text-primary">100%</p>
                <p className="text-sm text-foreground-muted">Quality Focused</p>
              </div>
              <div>
                <p className="text-3xl font-serif font-bold text-primary">ISO 9001</p>
                <p className="text-sm text-foreground-muted">Compliant</p>
              </div>
              <div>
                <p className="text-3xl font-serif font-bold text-primary">24/7</p>
                <p className="text-sm text-foreground-muted">Support</p>
              </div>
            </div>
          </div>
          
          {/* Right: Image */}
          <div className="fade-in relative">
            <div className="relative rounded-2xl overflow-hidden shadow-elegant">
              <img
                src="https://images.unsplash.com/photo-1561536441-01351ded5ffd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2VsZGluZ3xlbnwwfHx8fDE3Njk2ODk1MzZ8MA&ixlib=rb-4.1.0&q=85"
                alt="High-precision welding with sparks"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-secondary text-secondary-foreground px-6 py-4 rounded-xl shadow-elegant">
              <p className="text-sm font-medium">Ready to Serve</p>
              <p className="text-2xl font-serif font-bold">All Industries</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
